// removed by extract-text-webpack-plugin
module.exports = {"base":"DisabledCard_base--V3GX4"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/DisabledCard/DisabledCard.scss
// module id = 2354
// module chunks = 11